/**
 * BrandSpinner - Animated Kaleido brandmark spinner
 * 
 * Reusable spinning logo for loading states throughout the app.
 * Uses the Kaleido brandmark with CSS spin animation.
 * 
 * @param {string} size - Size class: 'sm' (16px), 'md' (24px), 'lg' (32px), 'xl' (48px)
 * @param {string} className - Additional CSS classes
 * @param {string} alt - Accessible label; pass an empty string for decorative use
 */
export function BrandSpinner({ size = 'md', className = '', alt = 'Loading' }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  };

  return (
    <img 
      src="/static/kaleido-emblem.svg"
      alt={alt}
      aria-hidden={alt === '' ? 'true' : undefined}
      className={`animate-spin ${sizeClasses[size] || sizeClasses.md} ${className}`}
    />
  );
}
